<template>
  <masonry
    ref="masonry"
    class="masonry pt-6 px-3"
    :cols="{ default: 4, 1980: 3, 1280: 2, 600: 1 }"
    :gutter="{ default: '24px', 800: '12px' }"
    :style="{ height: ht }"
  >
    <v-card v-for="(item, i) in tableItems" :key="i" class="mb-6" @click="$emit('rowClick', item)">
      <div v-if="item.type === 'FOLDER'" :class="{ 'grey lighten-3': !darkMode, 'grey darken-3': darkMode, 'text-center': true }" style="position: relative">
        <v-icon style="font-size: 200px">
          {{ item.icon }}
        </v-icon>
        <div v-if="item.favorite || item.unread || item.tags.length > 0 || item.unconfirmed" :class="{ 'image-overlay pa-2': true, dark: darkMode }">
          <v-badge v-if="item.unread > 0" :color="theme.unreadBadgeColor" class="ml-2" :content="item.unread" :offset-x="item.unconfirmed === 0 ? '20' : '40'">
          </v-badge>
          <v-badge v-if="item.unconfirmed > 0" :color="theme.toAcknowledgeBadgeColor" class="ml-2" :content="item.unconfirmed" offset-x="20">
          </v-badge>
          <v-icon v-if="item.tags.length > 0" color="grey" class="ml-2"> mdi-tag-multiple </v-icon>
          <v-icon v-if="item.favorite" :value="item.favorite" :color="theme.elements.activeColor" class="ml-2" inline>
            {{ mx_icons.favoriteIconActive }}
          </v-icon>
        </div>
      </div>

      <v-img v-else-if="item.type === 'ARTICLE' || item.type === 'IMAGE'" :src="getMediaUrl(item.mediaId)">
        <div v-if="item.favorite || item.unread || item.unconfirmed" :class="{ 'image-overlay pa-2': true, dark: darkMode }">
          <v-icon v-if="item.unread && !item.unconfirmed" :color="theme.unreadBadgeColor" class="ml-2"> mdi-checkbox-blank-circle </v-icon>
          <v-icon v-if="item.unconfirmed" :color="theme.toAcknowledgeBadgeColor" class="ml-2"> mdi-checkbox-blank-circle </v-icon>
          <v-icon v-if="item.favorite" :value="item.favorite" :color="theme.elements.activeColor" class="ml-2" inline>
            {{ mx_icons.favoriteIconActive }}
          </v-icon>
        </div>
      </v-img>

      <div v-else :class="{ 'grey lighten-3': !darkMode, 'grey darken-3': darkMode, 'text-center': true }" style="position: relative">
        <v-icon style="font-size: 200px">
          {{ item.icon }}
        </v-icon>
        <div v-if="item.favorite || item.unread || item.unconfirmed" :class="{ 'image-overlay pa-2': true, dark: darkMode }">
          <v-icon v-if="item.unread && !item.unconfirmed" :color="theme.unreadBadgeColor" class="ml-2"> mdi-checkbox-blank-circle </v-icon>
          <v-icon v-if="item.unconfirmed" :color="theme.toAcknowledgeBadgeColor" class="ml-2"> mdi-checkbox-blank-circle </v-icon>
          <v-icon v-if="item.favorite" :value="item.favorite" :color="theme.elements.activeColor" class="ml-2" inline>
            {{ mx_icons.favoriteIconActive }}
          </v-icon>
        </div>
      </div>

      <v-card-title class="body-1"> {{ item.name }} </v-card-title>
      <v-card-subtitle v-if="item.description">{{ item.description }}</v-card-subtitle>
      <v-card-text v-if="item.tags.length > 0">
        <span v-for="(tagId, i) in item.tags" :key="i">
          <v-chip v-if="tagsById[tagId]" class="mr-1 mb-1 px-2" small>{{ tagsById[tagId].name }}</v-chip>
        </span>
      </v-card-text>
    </v-card>
  </masonry>
</template>

<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';
import index from '@/modules/media';

export default {
  name: 'MediaModuleMasonryLayout',
  mixins: [common],
  props: {
    currentChildren: Object,
    tableItems: Array,
  },
  data() {
    return {
      ht: '100%',
      interval: null,
    };
  },
  computed: {
    ...mapState('media', ['mediasById', 'tagsById']),
  },
  methods: {
    getMediaUrl(mediaId) {
      let articleMediaUrl = '';
      let media = this.mediasById[mediaId];
      if (media && media.properties && media.properties.filename && media.properties.checksum) {
        articleMediaUrl = this.moduleFileUrl(index.moduleId, media.properties.filename, media.properties.checksum);
      }
      return articleMediaUrl;
    },
    handleResize() {
      /*
      var itemIcons = document.getElementsByClassName('itemIcon');
      for (let itemIcon of itemIcons) {
        itemIcon.style.fontSize = Math.floor(itemIcon.parentNode.getBoundingClientRect().width) + 'px';
      }
      */
      if (this.$refs.masonry) {
        const ht = window.innerHeight - this.$refs.masonry.$el.getBoundingClientRect().y - 54 + 'px';
        this.ht = ht;
        for (let cNode of this.$refs.masonry.$el.childNodes) {
          let cHt = 0;
          for (let rNode of cNode.childNodes) {
            const oHt = rNode.offsetHeight;
            const rSt = getComputedStyle(rNode);
            const rHt = oHt + parseInt(rSt.marginTop) + parseInt(rSt.marginBottom);
            cHt += rHt;
          }
          cNode.style.height = cHt + 'px';
        }
      }
    },
  },
  watch: {
    currentChildren(to, from) {
      window.setTimeout(() => {
        this.handleResize();
      }, 500);
    },
  },
  mounted() {
    window.addEventListener('resize', setTimeout.bind(null, this.handleResize, 500));
    this.interval = setInterval(this.handleResize, 3000);
    window.setTimeout(() => {
      this.handleResize();
    }, 500);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.masonry {
  overflow-y: auto;
}
.v-card {
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.24) 0px 2px 16px 0px !important;
}
.ellipsis {
  display: inherit;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.image-overlay {
  display: block;
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: right;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 100%);
}
.image-overlay.dark {
  background: rgb(0, 0, 0);
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
}
</style>
